module.exports = "https://r.zoocdn.com/_next/static/images/Countryside_icon-a160f9e99a96afaf1b4915ea5c9431b4.png";